module.exports = __webpack_public_path__ + "static/img/ziliao2.1a3a0e80.png";